import { AssetType } from '@seek/brand-types';
import { StrategiesEnum, type CroppedInfo } from '@seek/image-service-types';

const logoStrategies = [
  StrategiesEnum.JDP_LOGO,
  StrategiesEnum.SERP_LOGO,
  StrategiesEnum.SERP_LOGO_LEGACY,
];

// @remove when thumbnail is used everywhere instead
const legacyCoverStrategies = [StrategiesEnum.JDP_COVER_MOBILE_SMALL_LEGACY];

const coverStrategies = [
  StrategiesEnum.JDP_COVER_LEGACY,
  StrategiesEnum.JDP_COVER,
  StrategiesEnum.JDP_COVER_THUMBNAIL,
];

export const getAssetStrategies = (
  type: AssetType,
  croppedInfo?: CroppedInfo,
) => {
  if (type === AssetType.LOGO) {
    return logoStrategies.map((strategyName) => ({ name: strategyName }));
  } else if (type === AssetType.COVER) {
    return [
      ...legacyCoverStrategies.map((strategyName) => ({
        name: strategyName,
      })),
      ...coverStrategies.map((name) => ({
        name,
        ...croppedInfo,
      })),
    ];
  }
  return [];
};
